import { faCheckCircle, faClock, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InvoicePreviewSelect from '../../components/invoice-preview-select/invoice-preview-select';

export const formatDate = (unformattedDate, backupDate) => {
  if (!unformattedDate) return backupDate ? `${backupDate}*` : '';

  if (typeof unformattedDate === 'string') {
    const match = unformattedDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
  }

  const date = unformattedDate instanceof Date ? unformattedDate : new Date(unformattedDate);
  if (isNaN(date)) return backupDate ? `${backupDate}*` : '';

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const seperateMatchedAndUnmatchedExpenses = (statement) => {
  let matchedExpenses = [];
  let unmatchedExpenses = [];

  if (!statement || !statement.expenses) return { matchedExpenses, unmatchedExpenses };
  for (const transaction of statement.transactions) {
    const matchedExpense = statement.expenses.find((expense) => expense.checksum === transaction.checksum);
    if (matchedExpense) {
      matchedExpenses.push(matchedExpense.checksum);
    }
  }

  unmatchedExpenses = statement.expenses.filter((expense) => !matchedExpenses.includes(expense.checksum));
  return { matchedExpenses, unmatchedExpenses };
};

export const mapTransactionsData = (statement, t, navigate, updateTransaction, removeExpense, additionalExpenseOptions) => {
  const { matchedExpenses } = seperateMatchedAndUnmatchedExpenses(statement);

  return statement.transactions.map((transaction) => {
    const matchedExpense = statement?.expenses?.find((expense) => expense.checksum === transaction.checksum);
    const date = formatDate(transaction.date);
    return {
      ...transaction,
      account_mask: `**** **** **** ${transaction.account_mask}`,
      matched_expense: (
        <InvoicePreviewSelect
          transaction={transaction}
          statement={statement}
          updateTransaction={(updatedTransaction) => {
            updateTransaction(updatedTransaction);
          }}
          matchingExpenses={matchedExpenses || []}
          removeExpense={(transaction) => removeExpense(transaction)}
          additionalExpenseOptions={additionalExpenseOptions}
        />
      ),
      review_transaction: statement?.card_type == 'personal-card' && (
        <button
          disabled={['Processing'].includes(statement.status) || !transaction.checksum}
          className={`btn  ${transaction.json?.Reviewed ? 'btn-success' : 'btn-danger'}`}
          onClick={() => {
            if (['Pending', 'Processing'].includes(statement.status) !== 'Processing') {
              navigate(`/c_card/statement/transaction/${statement._id}/${transaction.checksum}`);
            }
          }}
        >
          {t.read('review')}
        </button>
      ), 
        matched_expense_name: matchedExpense ? <div className='matched-expense-name text-truncate'>{matchedExpense.original_file_name || matchedExpense.name || matchedExpense.json?.Name}</div> 
            : transaction?.json?.from_category === true ? <div className='matched-expense-name text-truncate'>{transaction.name}</div> : '',
      account_subtype: transaction.account_subtype,
      account_type: transaction.account_type,
      amount: `${Number(transaction.amount).toFixed(2)}$`,
      currency_code: transaction.currency_code,
      date: date,
      authorized_date: formatDate(transaction.authorized_date, date),
      merchant_name: transaction.merchant_name,
      transaction_name: transaction.transaction_name,
      pending: transaction.pending ? (
        <div data-transaction='pending'>
          <FontAwesomeIcon icon={faClock} style={{ color: 'orange' }} /> {t.read('cc_transactions.pending')}
        </div>
      ) : (
        <div data-transaction='processed'>
          <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }} /> {t.read('cc_transactions.processed')}
        </div>
      ),
      ready_for_submit: transaction.readyForSubmit ? (
        <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }} />
      ) : (
        <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red' }} />
      ),
      submitted: transaction.submitted ? (
        <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }} />
      ) : (
        <FontAwesomeIcon icon={faTimesCircle} style={{ color: 'red' }} />
      ),
      raw_transaction: { ...transaction, matched_expense: matchedExpense ? matchedExpense.name : null },
    };
  });
};

export const filterPendingTransactions = (transactions, showPending) => {
  if (showPending) {
    return transactions;
  }
  return transactions.filter((transaction) => transaction.pending.props['data-transaction'] === 'processed');
};

export const calculateAmountTotal = (transactions) => {
  const total = transactions.reduce((sum, transaction) => {
    const amount = parseFloat(transaction.amount.replace('$', '').replace(/\s/g, '').replace(',', '.'));
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const formatted = total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return `${formatted}$`;
};
